module.exports = __webpack_public_path__ + "static/pinkbunny2-718e482dd5508586324880fe61b169be.png";